<!-- Divider -->
<div
    class="platform-horizontal-navigation-item-wrapper divider"
    [ngClass]="item.classes?.wrapper"></div>
